/** `Math.floor((score − 10) / 2)` for any integer: −5 at 1, 0 at 10 and 11, +10 at 30. */
export function abilityModifier(score) {
    return Math.floor((score - 10) / 2);
}
/** +2 for CR 0 to 4 (fractions included), then +1 per four ratings, up to +9 at CR 29 and 30. */
export function proficiencyForChallenge(cr) {
    if (!(cr >= 5))
        return 2;
    return Math.min(9, Math.floor((cr - 1) / 4) + 2);
}
/** Experience points by challenge rating, the 2014 table (CR 0 is 10). */
export const XP_BY_CHALLENGE = {
    0: 10,
    0.125: 25,
    0.25: 50,
    0.5: 100,
    1: 200,
    2: 450,
    3: 700,
    4: 1100,
    5: 1800,
    6: 2300,
    7: 2900,
    8: 3900,
    9: 5000,
    10: 5900,
    11: 7200,
    12: 8400,
    13: 10000,
    14: 11500,
    15: 13000,
    16: 15000,
    17: 18000,
    18: 20000,
    19: 22000,
    20: 25000,
    21: 33000,
    22: 41000,
    23: 50000,
    24: 62000,
    25: 75000,
    26: 90000,
    27: 105000,
    28: 120000,
    29: 135000,
    30: 155000,
};
/** The table's XP for a rating; 0 for a number that is not a 2014 challenge rating. */
export function xpForChallenge(cr) {
    return XP_BY_CHALLENGE[cr] ?? 0;
}
/** The hit die by size: Tiny d4, Small d6, Medium d8, Large d10, Huge d12, Gargantuan d20. */
export const HIT_DIE_BY_SIZE = {
    tiny: 4,
    sm: 6,
    med: 8,
    lg: 10,
    huge: 12,
    grg: 20,
};
export function hitDieForSize(size) {
    return HIT_DIE_BY_SIZE[size] ?? 8;
}
/**
 * `Math.floor(count × (die + 1) / 2) + bonus`: 7 for 2d6, 58 for 9d8 + 18, −1 for 1d4 − 3, the bonus
 * for a count of 0. It may be negative; a hit-point use floors it at 1, a damage use at 0.
 */
export function averageOfDice(dice) {
    return Math.floor((dice.count * (dice.die + 1)) / 2) + dice.bonus;
}
//# sourceMappingURL=tables.js.map